import { useEffect, useState } from "react";

import { BranchContext } from "./BranchContext";

import httpclient from "../../Utils";
import useTokenRefresh from "../../Hooks/useTokenRefresh";
import { useApiErrorHandler } from "../../Hooks/useApiErrorHandler";

const BranchProvider = ({ children }) => {
  const [branches, setBranches] = useState([]);
  const [currentBranch, setCurrentBranch] = useState(
    localStorage.getItem("branch_code") || ""
  );
  const [loading, setLoading] = useState(false);

  const { getTokenRefreshed: refresh } = useTokenRefresh();
  const handleApiError = useApiErrorHandler();

  const getBranches = async () => {
    setLoading(true);
    const API_URL = "branch-list";

    try {
      const res = await httpclient.get(API_URL);
      const { data } = res;

      if (data.status === 200) {
        setBranches(data.data);
      }
    } catch (error) {
      // handleApiError(error); // optionally refresh if 401
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getBranches();
  }, []);

  const updateCurrentBranch = (branch) => {
    localStorage.setItem("branch_code", branch);
    setCurrentBranch(branch);
  };

  return (
    <BranchContext.Provider
      value={{
        branches,
        currentBranch,
        setCurrentBranch: updateCurrentBranch,
        loading,
      }}
    >
      {children}
    </BranchContext.Provider>
  );
};

export default BranchProvider;
